export const walletHead = [
  {
    title: "comment",
    key: "comment",
  },
  {
    title: "status",
    key: "status",
  },
  {
    title: "type",
    key: "type",
  },
  {
    title: "category",
    key: "category",
  },
  {
    title: "bot_single.amount",
    key: "amount",
  },
  {
    title: "date",
    key: "date",
  },
];
